module.exports = __webpack_public_path__ + "static/media/jewels-crush.4e37dcb9.jpg";